(function() {
  var Service,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Service = App.loadClass('core::Angular/Service');

  exports.RowClearingService = (function(superClass) {
    extend(RowClearingService, superClass);

    function RowClearingService(http, rootScope) {
      this.http = http;
      this.rootScope = rootScope;
      this.handleRowClick = bind(this.handleRowClick, this);
      this.clearSingle = bind(this.clearSingle, this);
      this.bulkClearSelectAll = bind(this.bulkClearSelectAll, this);
      this.setTableClass = bind(this.setTableClass, this);
      this.handleBulkClear = bind(this.handleBulkClear, this);
      this.bulkClear = bind(this.bulkClear, this);
      this.clear_selections = [];
      this.bulkClearing = false;
      this.selectedAll = false;
      this.clearBtnText = 'Bulk Clear';
      this.selectBtnText = 'Select All';
      this.bulkClear = this.bulkClear;
      this.setTableClass = this.setTableClass;
      this.bulkClearSelectAll = this.bulkClearSelectAll;
      this.handleRowClick = this.handleRowClick;
      this.clearSingle = this.clearSingle;
    }

    RowClearingService.prototype.bulkClear = function() {
      var child, i, j, len, ref, results, row;
      if (this.scope.clear_selections.length > 0) {
        return this.handleBulkClear();
      } else {
        this.scope.bulkClearing = !this.scope.bulkClearing;
        this.scope.clearBtnText = this.scope.bulkClearing ? 'Cancel Clear' : 'Bulk Clear';
        ref = this.scope.rows;
        results = [];
        for (j = 0, len = ref.length; j < len; j++) {
          row = ref[j];
          if (this.scope.bulkClearing) {
            row.rowClass = 'multidelete alert-success';
          } else {
            row.rowClass = '';
          }
          results.push((function() {
            var ref1, results1;
            ref1 = this.scope.rows.children;
            results1 = [];
            for (i in ref1) {
              child = ref1[i];
              results1.push(child.rowClass = 'multidelete alert-success');
            }
            return results1;
          }).call(this));
        }
        return results;
      }
    };

    RowClearingService.prototype.handleBulkClear = function() {
      var index, j, len, msg, record, ref;
      msg = this.loader.overMap('Loading...');
      ref = this.scope.clear_selections;
      for (j = 0, len = ref.length; j < len; j++) {
        record = ref[j];
        index = this.scope.conversion_records.indexOf(record);
        this.scope.conversion_records.splice(index, 1);
      }
      this.mcs.clearConversionRecords(this.scope.clear_selections);
      this.scope.clear_selections = [];
      this.scope.bulkClearing = false;
      this.bulkClear();
      this.setTableClass();
      $(window).trigger('resize');
      return true;
    };

    RowClearingService.prototype.setTableClass = function() {
      if (this.scope.bulkClearing) {
        return 'clickable';
      } else {
        return 'table-striped';
      }
    };

    RowClearingService.prototype.bulkClearSelectAll = function() {
      var index, j, len, record, ref, results;
      this.scope.selectedAll = !this.scope.selectedAll;
      this.scope.clearBtnText = this.scope.selectedAll ? 'Clear Selected' : 'Cancel Clear';
      ref = this.scope.conversion_records;
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        record = ref[j];
        if (this.scope.selectedAll) {
          if (this.scope.clear_selections.indexOf(record) === -1 && record.canClear) {
            record.rowClass = 'multidelete alert-error';
            results.push(this.scope.clear_selections.push(record));
          } else {
            results.push(void 0);
          }
        } else {
          if (record.canClear) {
            record.rowClass = 'multidelete alert-success';
            index = this.scope.clear_selections.indexOf(record);
            results.push(this.scope.clear_selections.splice(index, 1));
          } else {
            results.push(void 0);
          }
        }
      }
      return results;
    };

    RowClearingService.prototype.clearSingle = function(record) {
      var index, msg;
      msg = this.loader.overMap('Loading...');
      this.scope.clear_selections.push(record);
      index = this.scope.conversion_records.indexOf(record);
      this.scope.conversion_records.splice(index, 1);
      this.mcs.clearConversionRecords(this.scope.clear_selections);
      this.scope.clear_selections = [];
      $(window).trigger('resize');
      return true;
    };

    RowClearingService.prototype.handleRowClick = function(record) {
      var index;
      if (!this.scope.bulkClearing) {
        return;
      }
      if (record.rowClass === 'multidelete alert-success') {
        record.rowClass = 'multidelete alert-error';
        this.scope.clear_selections.push(record);
      } else if (record.rowClass === 'multidelete alert-error') {
        record.rowClass = 'multidelete alert-success';
        index = this.scope.clear_selections.indexOf(record);
        this.scope.clear_selections.splice(index, 1);
      }
      return this.scope.clearBtnText = this.scope.clear_selections.length > 0 ? 'Clear Selected' : 'Cancel Clear';
    };

    return RowClearingService;

  })(Service);

}).call(this);
